<div class="modal-form container-fluid">

    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-12">
                <h2 class="jumbotron-heading">Client Login Link</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                Copy your client's login link, or let us send the email for you! It will remain active for 30 days.
            </div>
        </div>

        <div class="row mt-2">
            <button mat-menu-item (click)="onCopyLink()" title="Copies the client link to your clipboard"><fa-icon
                    icon="copy"></fa-icon>&nbsp;&nbsp; Copy</button>
        </div>
        <div class="row">
            <button mat-menu-item (click)="onSendLink()" title="Emails your client their login link"><fa-icon
                    icon="paper-plane"></fa-icon>&nbsp;&nbsp; Email Login Link</button>
        </div>

        <lgv-loading-indicator *ngIf="IsLoadingLink$ | async" [CSSClass]="'Small Floating'">
        </lgv-loading-indicator>

        <div class="Vert-15"></div>
        <div class="col-12">
            <div class="alert alert-info smallFont" style="border: 1px dashed black; word-break: break-all;">
                {{ ClientTokenUrl }}
            </div>
        </div>

        <div class="Vert-10"></div>
        <div class="row">
            <div class="col-12" align="end">
                <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                    style="margin-right:10px;">
                    Close
                </button>
            </div>
        </div>

    </mat-dialog-content>
</div>